import {useEffect} from 'react';
import {UWM_INIT_MARKET_LOCALE, UWM_NAVIGATE_TO_GROUP} from '@/consts/eventTypes';
import useEventListener from '@/hooks/useEventListener';
import useWindowEventListener from '@/hooks/useWindowListener';
import {proceedAppInit} from '@/services/appService';
import eventMessagesService from '@/services/events/eventMessagesService';

export const TIPS_NAVIGATE_TO_GROUP_EVENT = 'tips:navigate-to-group';

const useEvents = () => {
    const init = async (detail: any) => {
        const {command, payload} = detail || {};
        if (command === UWM_INIT_MARKET_LOCALE) {
            await proceedAppInit(payload);
            return;
        }

        if (command === UWM_NAVIGATE_TO_GROUP) {
            eventMessagesService.sendModuleLoadingStart();
            document.dispatchEvent(
                new CustomEvent(TIPS_NAVIGATE_TO_GROUP_EVENT, {
                    detail: {groupType: payload?.groupType},
                })
            );
        }
    };

    useEffect(() => {
        eventMessagesService.sendLoadedMessageToParent();
    }, []);

    useEffect(() => {
        const handleSwMessage = (event: MessageEvent) => {
            const {type} = event.data || {};

            if (type === 'PRECACHE_MEDIA_DONE') {
                eventMessagesService.sendMediaCachedMessage();
            }
        };

        navigator.serviceWorker?.addEventListener('message', handleSwMessage);

        return () => {
            navigator.serviceWorker?.removeEventListener('message', handleSwMessage);
        };
    }, []);

    useWindowEventListener('message', (event) => {
        // @ts-expect-error
        init(event.data.detail);
    });

    useEventListener('UwmCommand', (event) => {
        // @ts-expect-error
        init(event.detail);
    });
};

export default useEvents;
